/** Deep link to a match's Sportradar (SIR) page, picked out of a watch-group's
 * per-site links. Host/path are validated the same way `polymarketEventUrl`
 * validates its input — the links come from the DB and must never turn into an
 * unsafe link in the dashboard. Returns the canonical overview URL (query/token
 * dropped), or null when the group carries no SIR link. */
export function sportradarUrl(links: string[] | undefined): string | null {
  for (const raw of links ?? []) {
    let url: URL;
    try {
      url = new URL(raw.trim());
    } catch {
      continue;
    }
    if (url.protocol !== "https:") continue;
    const host = url.hostname.toLowerCase();
    if (!/(^|\.)sir\.sportradar\.com$/.test(host)) continue;
    // /en/match/53452521 (optionally /statistics, /report, …) — same shape the
    // monitor's sportradar adapter parses.
    const m = /^\/[a-z]{2}\/match\/(\d+)/i.exec(url.pathname);
    if (!m) continue;
    return `https://scores.sir.sportradar.com/en/match/${m[1]}`;
  }
  return null;
}
